import React, { useCallback, useContext, useEffect, useState } from 'react';

import { Dashboard, Summary } from '|/app/services';
import MobileNavigationRailContext from '|/context/mobile-navigation-rail-context';
import MobileNavigationRail from './components/mobile-navigation-rail';
import NavRailModals from './components/modals/nav-rail-modals';
import NavigationRail from './components/navigation-rail';
import { useNavigationRailVm } from './hooks/use-navigation-rail-vm';

interface ResponsiveNavigationRailProps {
  dashboard: Dashboard | null;
  summary: Summary | null;
  onNavigate?: () => void;
}

const ResponsiveNavigationRail: React.FC<ResponsiveNavigationRailProps> = ({
  dashboard = null,
  summary = null,
  onNavigate = () => undefined
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const { setShowMobileNavigationRail } = useContext(MobileNavigationRailContext);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const closeDrawer = useCallback(() => {
    setShowMobileNavigationRail(false);
  }, [setShowMobileNavigationRail]);

  // The view model is owned here, above the drawer, so the modals below survive it closing.
  const vm = useNavigationRailVm({
    dashboard,
    summary,
    onNavigate: isMobile ? closeDrawer : onNavigate
  });

  return (
    <>
      {isMobile ? (
        <MobileNavigationRail dashboard={dashboard} summary={summary}>
          <NavigationRail vm={vm} />
        </MobileNavigationRail>
      ) : (
        <NavigationRail vm={vm} />
      )}

      {vm.isRailVisible && <NavRailModals vm={vm} />}
    </>
  );
};

export default ResponsiveNavigationRail;
